module.exports = __webpack_public_path__ + "img/on-hold.9610fbdf.svg";